export enum StatusType {
  DOCUMENT = 'DOCUMENT',
  PROCEDURE = 'PROCEDURE'
}
